import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", null, "Изображение", -1)
const _hoisted_2 = { style: {"display":"flex","justify-content":"center"} }
const _hoisted_3 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Modal = _resolveComponent("Modal")!

  return (_ctx.isImage)
    ? (_openBlock(), _createBlock(_component_Modal, {
        key: 0,
        onOnsuccess: ($event: any) => (null)
      }, {
        title: _withCtx(() => [
          _hoisted_1
        ]),
        content: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("img", {
              style: {"object-fit":"cover","max-width":"100%","max-height":"400px"},
              src: _ctx.url,
              alt: "image"
            }, null, 8, _hoisted_3)
          ])
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}